var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[
    'col',
    ..._vm.colSizes,
    ..._vm.colOffsets,
  ]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }